import baseConfig from "./base";

// dlgrma config
let qld_config = {
  client_department_acronym: "DLGRMA",
  client_department_name:
    "Department of Local Government, Racing and Multicultural Affairs",
  client_branch_name: "Multicultural Affairs",
  client_contact_url: "https://www.dlgrma.qld.gov.au/contact-us-dlgrma",
  client_contact_tel: "13 74 68",
  client_contact_tel_alpha: "13 QGOV",
  client_tty_number: "133 677",
  client_deaf_number: "1300 555 727",
  client_translation_tel: "131 450",
  support_email: "support@geografia.com.au",
  admin_state_name: "Queensland",
  admin_state_acronym: "QLD",
  admin_state_local: "Queenslander",
  admin_stats_latest_year: "2016",
  admin_sa1_count: 11563, //TODO make this scoped by year
  admin_lga_count: 78,
  admin_sed_count: 93,
  cartodb_username: "dlgrma",
  title: "DLGRMA-Online Population Resource",
  choropleth_color_ramp: "Greens",
  map_color: "#007b77",
  department_url: "https://www.dlgrma.qld.gov.au",
  video_link_about_this_site: "https://www.youtube.com/embed/Lyr_1qPc46Q",
  video_link_how_to_find_area_profile:
    "https://www.youtube.com/embed/R7V8Lg87QYA",
  video_link_how_to_find_community_profile:
    "https://www.youtube.com/embed/T0iv4oMwQ8Y",
  disclaimer_template: `Please note, the {{geo_aggregation}} defined on this website is taken from the latest update to the Australian Statistical Geography Standard (ASGS) and is current as of the date of publication. The source of the data is the relevant Census of Population and Housing and may have been re-coded to fit these latest geographies. For more information,`,
  abs_url: "http://www.abs.gov.au/ausstats/abs@.nsf/mf/1270.0.55.003",
  google_analytics_id: "UA-86661193-3",
  quick_guide_link:
    "https://dlgrma.s3-ap-southeast-2.amazonaws.com/public/Search+Diversity+QLD+-+Quick+Guide.pdf",
  primary_chart_color: "rgba(234, 89, 57, 1)",
  secondary_chart_color: "rgba(0, 123, 119, 1)",
  lga_boundary_year: {
    "2021": 18,
    "2016": 18,
    "2011": 11
  },
  sed_boundary_year: {
    "2021": 18,
    "2016": 18,
    "2011": 11
  },
  map_coords: {
    first: {
      lat: -31,
      long: 28
    },
    second: {
      lat: -8,
      long: 156
    }
  }
};

// dlgsc config
let wa_config = {
  client_department_acronym: "DLGSC",
  client_department_name:
    "Office of Multicultural Interests, the Department of Local Government, Sport and Cultural Industries",
  client_branch_name: "Office of Multicultural Interests",
  client_contact_url: "https://www.dlgsc.wa.gov.au/department/contact-us", // TODO: add 
  client_contact_tel: "61 8 6552 7300",
  client_contact_tel_alpha: "",
  client_tty_number: "133 677",
  client_deaf_number: "1300 555 727",
  client_translation_tel: "131 450",
  support_email: "support@geografia.com.au",
  admin_state_name: "Western Australia",
  admin_state_acronym: "WA",
  admin_state_local: "Western Australian",
  admin_stats_latest_year: "2021",
  admin_sa1_count: 5984, //TODO make this scoped by year
  admin_lga_count: 139,
  admin_sed_count: 61,
  cartodb_username: "dlgc",
  title: "DLGSC-Online Population Resource",
  choropleth_color_ramp: "Blues",
  map_color: "#00427b",
  department_url: "https://www.dlgsc.wa.gov.au",
  video_link_about_this_site: "https://www.youtube.com/embed/OEaM36uidsQ",
  video_link_how_to_find_area_profile:
    "https://www.youtube.com/embed/DzklvN3QOmM",
  video_link_how_to_find_community_profile:
    "https://www.youtube.com/embed/4_72K0Z6Mr0",
  disclaimer_template: `Please note, the {{geo_aggregation}} defined on this website is taken from the latest update to the Australian Statistical Geography Standard (ASGS) and is current as of the date of publication. The source of the data is the relevant Census of Population and Housing and may have been re-coded to fit these latest geographies. For more information,`,
  abs_url: "http://www.abs.gov.au/ausstats/abs@.nsf/mf/1270.0.55.003",
  google_analytics_id: "G-85R4HD55BQ",
  quick_guide_link:
    "https://dlgsc.s3-ap-southeast-2.amazonaws.com/public/Search+Diversity+WA+-+Quick+Guide.pdf",
  primary_chart_color: "rgba(150,182,229, 1)",
  secondary_chart_color: "rgba(249, 99, 2, 1)",
  lga_boundary_year: {
    "2021": 21,
    "2016": 16,
    "2011": 11
  },
  sed_boundary_year: {
    "2021": 21,
    "2016": 16,
    "2011": 11
  },
  map_coords: {
    first: {
      lat: -38.55,
      long: 109.39
    },
    second: {
      lat: -7.97,
      long: 136.58
    }
  }
};

const config = process.env.STATE === "qld" ? qld_config : wa_config;

export default Object.freeze(Object.assign({}, baseConfig, config));



// WEBPACK FOOTER //
// ./config/index.js